import { props } from 'ts-action';

export const PLATFORM_EXPLORE_NAVIGATION_TOGGLE = {
	category: '[Platform]',
	name: 'Global Explore Navigation',
	payload: props<{ isOpened: boolean }>(),
} as const;
